<template>
    <div class="EnergyAnalysis">
        <Title firstName="能耗分析" lastName="ENERGY CONSUMPTION ANALYSIS" />
        <div class="echarts">
            <div class="tag">
                <span :class="{active:acindex==0}" @click="changeIdx(0)">日</span>
                <span :class="{active:acindex==1}" @click="changeIdx(1)">月</span>
            </div>
            <div class="state" >
                <div class="item" v-for="(item,index) in this.list[acindex]" :key="index" >
                <div class="title">{{item.name}}</div>
                <div class="num">{{item.value}}<span>{{item.unit}}</span><img src="../../../../assets/img/up.png" alt="" v-if="item.isdown"><img src="../../../../assets/img/down.png" alt="" v-if="!item.isdown" ></div>
                </div>
            </div>
            <div class="charts" v-if="$store.state.nav == 'overview'">
                <Graph :chartId="chartId" :seriesData="seriesOption" unit="kWh" :seriesData1="seriesOption1" :type="typeObject" :xData="xData" v-if="seriesOption.length >0"/>
            </div>
            <div class="bottom"></div>
        </div>
    </div>
</template>

<script>
import * as echarts from "echarts";
import { mapState } from "vuex";
const Title = () => import("../../../../components/title/Title.vue");
const SelectList = () => import("../../../../components/title/selectList.vue");
const Bar = () => import("../../../../components/echarts/bar.vue");
const charts = () => import("../../../../components/echarts/charts.vue");
const Graph = () => import("../../../../components/echarts/graph.vue");
import { getSevenDays, lastMonth, getMonthDays, getTodayTime, getTodayYesTime } from "../../../../utils/common/index";
export default {
    data() {
        return {
            chartId: "EnergyAnalysis",
            xData: [], // 当前时间轴
            xData1: [], // 24小时
            xData2:[], // 本月的日期
            seriesData: [],
            total: "",
            yData: "",
            acindex:0,
            seriesOption:[],
            seriesOption1:[],
            dayEnergy:[],
            days:[], // 本月每天用电量数组
            list:[
                [
                    {
                        name:"日用电",
                        unit:"kWh",
                        value:"--",
                        isdown:true
                    },
                    {
                        name:"日用水",
                        unit:"m³",
                        value:"--",
                        isdown:false
                    },
                    {
                        name:"日折标煤",
                        unit:"kgce",
                        value:"--",
                        isdown:true
                    }
                ],
                [
                    {
                        name:"月用电",
                        unit:"kWh",
                        value:"--",
                        isdown:true
                    },
                    {
                        name:"月用水",
                        unit:"m³",
                        value:"--",
                        isdown:false
                    },
                    {
                        name:"月折标煤",
                        unit:"kgce",
                        value:"--",
                        isdown:true
                    }
                    
                ]
            ],
            yesdays:[],
            lastMonEnergy:[]
        };
    },
    components: {
        Title,
        SelectList,
        Bar,
        charts,
        Graph
    },
    computed: {
        routeName(){
            return this.$route.query.name;
        },
        
    },
    created() {
        for (let i = 0; i <= 24; i++) {
            this.xData1.push((i < 10 ? "0" + i : i) + ":00");
        }
        // 获取当月所有天数 
        this.xData2 = getMonthDays()

    },
    mounted() {
        this.getEnergy()
        this.getListvalue()
    },
    methods: {
        // 切换日月
        changeIdx(idx){
            this.acindex = idx

            if(idx == 1){
                // this.seriesOption =  [
                //     {
                //         data: this.days,
                //         type: "line",
                //     },
                // ]
                this.seriesOption =  this.lastMonEnergy 
                this.seriesOption1 =  this.days
                this.typeObject = {
                    data:'上月',
                    data2:'本月',
                }
                this.xData = this.xData2
            }else{
                this.seriesOption =  this.yesdays 
                this.seriesOption1 =  this.dayEnergy
                
                this.typeObject = {
                    data:'昨日',
                    data2:'今日',
                }
                this.xData = this.xData1
            }
        },
        // 获取用电图表数据
        async getEnergy() {
            let _this = this
            let dian = new Date().getHours()
            let day = new Date().getDate()
            let time = getTodayYesTime()
            let lastMon = lastMonth()
            console.log(time);
            console.log(lastMon);
            let data ={
                projectId:this.$store.state.projectId,
                date:`${time.today}T00:00:00Z`,
                powerType:'ELECTRICITY',
                range:'MONTH'
            }

            let dataToday ={
                projectId:this.$store.state.projectId,
                date:`${time.today}T00:00:00Z`,
                powerType:'ELECTRICITY',
                range:'DAY'
            }

            let dataYes ={
                projectId:this.$store.state.projectId,
                date:`${time.yesterday}T00:00:00Z`,
                powerType:'ELECTRICITY',
                range:'DAY'
            }

            let dataLastMon ={
                projectId:this.$store.state.projectId,
                date:`${lastMon}T00:00:00Z`,
                powerType:'ELECTRICITY',
                range:'MONTH'
            }
            
            let res = await Promise.all([
                _this.$http.energyConsumption(data), 
                _this.$http.energyConsumption(dataToday),
                _this.$http.energyConsumption(dataYes),
                _this.$http.energyConsumption(dataLastMon),
            ])
            console.log(res);
            // return 
            this.days = res[0].data.data.result.electricity.map(item =>{
                return item = Number(item).toFixed(2)
            }).slice(0,day)
            this.dayEnergy = res[1].data.data.result.electricity.map(item =>{
                return item = Number(item).toFixed(2)
            }).slice(0,dian)
            this.yesdays = res[2].data.data.result.electricity.map(item =>{
                return item = Number(item).toFixed(2)
            })
            this.lastMonEnergy = res[3].data.data.result.electricity.map(item =>{
                return item = Number(item).toFixed(2)
            })
            

            
            this.changeIdx(this.acindex)
        },
        async getListvalue(){
			let _this = this
			let data = {
				dateRange:'DAY',
				projectId:this.$store.state.projectId
			}
			let data2 = {
				dateRange:'MONTH',
				projectId:this.$store.state.projectId
			}
			let res = await Promise.all([_this.$http.getConsumptionSC(data), _this.$http.getConsumptionSC(data2)])
            
			this.$set(this.list, 0, [
					{
						name:"日用电",
						unit:"kWh",
						value:Number(res[0].data.data.proportion.energy).toFixed(2),
						isdown:true
					},
                    {
						name:"日用水",
						unit:"m³",
						value:Number(res[0].data.data.proportion.water).toFixed(2),
						isdown:false
					},
					{
						name:"日折标煤",
						unit:"kgce",
						value:Number(res[0].data.data.proportion.total).toFixed(2),
						isdown:true
					}
					
				],)
            this.$set(this.list, 1, [
					{
						name:"月用电",
						unit:"kWh",
						value:Number(res[1].data.data.proportion.energy).toFixed(2),
						isdown:true
					},
                    {
						name:"月用水",
						unit:"m³",
						value:Number(res[1].data.data.proportion.water).toFixed(2),
						isdown:false
					},
					{
						name:"月折标煤",
						unit:"kgce",
						value:Number(res[1].data.data.proportion.total).toFixed(2),
						isdown:true
					},
					
				])
		}
        
    },
};
</script>

<style lang="less" scoped>
.EnergyAnalysis {
    width: 20vw;
    // height: 493rem;
    position: fixed;
    top: 30.8vh;
    left: 2vw;
    z-index: 1;

    .state {
        padding: 1vh 1vw 2vh;
        display: flex;
        justify-content: space-between;
        font-size: 14rem;
        .item {
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: rgba(230, 243, 253, 0.7);
        text-align: center;
        .num {
            padding-top: 3rem;
            font-size: 20rem;
            color: #00deff;
            font-family: zcoolqingkehuangyouti;
            font-weight: 400;
            span {
            font-size: 14rem;
            margin-left: 3rem;
            }
            img{
            margin-left: 3rem;
            }
        }
        }
    }


    .echarts {
        overflow: hidden;
        position: relative;
        height: 32vh;
        padding-bottom: 1vh;
        background: linear-gradient(
        0deg,
        rgba(0, 33, 59, 0.6) 0%,
        rgba(3, 13, 24, 0.7) 100%
        );
        .tag{
            padding-top: 0.5vh;
        }
        
        .charts {
        height: 18vh;
        }
        .bottom {
        width: 20vw;
        height: 1vh;
        background: url(../../../../assets/img/板块装饰线.png) no-repeat;
        block-size: 100% 100%;
        position: absolute;
        bottom: 0;
        left: 0;
        }
    }
}
</style>
